import { createFeatureSelector } from '@ngrx/store';
import { ActionItemsState } from '@action-items/reducers';

export const selectActionItemsModule = createFeatureSelector<ActionItemsState>('actionItems');
